module.exports = __webpack_public_path__ + "img/GoPay-Digital-Donation-Outlook-967x683.fd04248c.png";